module.exports = __webpack_public_path__ + "assets/img/home_banner_bg.2b3fe64c.png";